import RestService from "~/core/services/rest.service";
import businessUnitService from "~/modules/businessUnit/services/businessUnit.service";
import type { FetchUserProfileParameters } from "~/modules/user/models/FetchUserProfileParameters.interface";
import type { UserProfile } from "~/modules/user/models/UserProfile.interface";
import type { UserProfileV2 } from "~/modules/user/models/UserProfileV2.interface";

class UserProfileBusinessUnitService extends RestService {
  /**
   * Retrieve userProfiles
   */
  getUserProfiles({
    businessUnitCode,
    searchParams,
  }: FetchUserProfileParameters): Promise<UserProfileV2[]> {
    const params = {
      filter: searchParams,
    };

    return this.$apiV2.get(
      `${businessUnitService.getBusinessUnitPath(businessUnitCode)}/profiles`,
      {
        params,
      },
    );
  }

  /**
   * Get multiple profiles
   * @param codes
   */
  getUserProfilesByCodes(codes: string[]): Promise<UserProfile[]> {
    const data = {
      codes,
    };
    const config = {
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
      },
    };
    return this.$api.post(
      `${businessUnitService.getBusinessUnitsPath()}/getUserProfilesByCodes`,
      data,
      config,
    );
  }
}

export default new UserProfileBusinessUnitService();
